module.exports = __webpack_public_path__ + "static/media/fvs_valve1_37.758433ff.jpg";